// ============================================================
// DashboardLayout — sidebar + outlet + statut socket
// ============================================================

import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useSocket } from '../hooks/useSocket';
import { useServerInfo } from '../hooks/useServerInfo';

export function DashboardLayout(): JSX.Element {
  const { user, logout } = useAuth();
  const { connected } = useSocket();
  // [2.13.0] Serveur de comptes seulement : les serveurs Siverix de ses comptes.
  const { info } = useServerInfo();

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', minHeight: '100vh' }}>
      <aside
        style={{
          background: 'var(--color-surface)',
          borderRight: '1px solid var(--color-border)',
          padding: '20px 16px',
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
        }}
      >
        <div style={{ fontSize: '18px', fontWeight: 700, marginBottom: '20px' }}>
          🔮 Siverix Admin
        </div>
        <Nav to="/" label="Vue d'ensemble" end />
        <Nav to="/users" label="Utilisateurs" />
        {info?.accountServer && <Nav to="/siverix-servers" label="Serveurs Siverix" />}
        <Nav to="/communities" label="Communautés" />
        <Nav to="/audit-log" label="Journal d'audit" />
        <Nav to="/moderation" label="Modération" />
        <Nav to="/bans" label="Bannissements" />
        <Nav to="/invites" label="Invitations" />
        <Nav to="/instance" label="Instance" />
        <Nav to="/health" label="Santé" />

        <div style={{ flex: 1 }} />

        <div style={{ fontSize: '12px', color: 'var(--color-text-muted)', marginBottom: '8px' }}>
          <span
            style={{
              display: 'inline-block',
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: connected ? 'var(--color-success)' : 'var(--color-error)',
              marginRight: 6,
            }}
          />
          {connected ? 'Temps réel actif' : 'Hors ligne'}
        </div>
        <div style={{ fontSize: '13px', marginBottom: '8px' }}>
          {user?.displayName ?? user?.username}
          <div style={{ fontSize: '11px', color: 'var(--color-text-muted)' }}>{user?.email}</div>
        </div>
        <button onClick={() => void logout()} style={secondaryButtonStyle}>
          Déconnexion
        </button>
      </aside>

      <main style={{ padding: '28px 40px', overflowY: 'auto' }}>
        <Outlet />
      </main>
    </div>
  );
}

function Nav({ to, label, end }: { to: string; label: string; end?: boolean }): JSX.Element {
  return (
    <NavLink
      to={to}
      end={end}
      style={({ isActive }) => ({
        display: 'block',
        padding: '8px 12px',
        borderRadius: '6px',
        color: isActive ? 'var(--color-accent)' : 'var(--color-text)',
        background: isActive ? 'rgba(88,166,255,.10)' : 'transparent',
        textDecoration: 'none',
        fontSize: '14px',
      })}
    >
      {label}
    </NavLink>
  );
}

const secondaryButtonStyle: React.CSSProperties = {
  padding: '8px 12px',
  background: 'transparent',
  color: 'var(--color-text)',
  border: '1px solid var(--color-border)',
  borderRadius: '6px',
  fontSize: '13px',
  cursor: 'pointer',
};
